function getMessageLink(message: Message<any>, conversation: Conversation) {
  return `/chat/${conversation.type}/${conversation._id}?message=${message._id}`
}

export default getMessageLink
